import * as i0 from '@angular/core';
import { EventEmitter, Component, ChangeDetectionStrategy, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import * as i1 from 'primeng/button';
import { ButtonModule } from 'primeng/button';

class ButtonComponent {
    label;
    icon;
    iconPos = 'left';
    class = '';
    fit = true;
    disabled = false;
    loading = false;
    severity;
    clicked = new EventEmitter();
    text;
    rounded;
    raised;
    outlined;
    emitClick() {
        if (!this.disabled) {
            this.clicked.emit();
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ButtonComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: ButtonComponent, isStandalone: true, selector: "a-button", inputs: { label: "label", icon: "icon", iconPos: "iconPos", class: "class", fit: "fit", disabled: "disabled", loading: "loading", severity: "severity", text: "text", rounded: "rounded", raised: "raised", outlined: "outlined" }, outputs: { clicked: "clicked" }, ngImport: i0, template: `
		<p-button
			[loading]="loading"
			[label]="label"
			[severity]="severity"
			[rounded]="rounded"
			[text]="text"
			[raised]="raised"
			[outlined]="outlined"
			[styleClass]="class"
			[icon]="icon"
			[iconPos]="iconPos"
			[style]="{ width: fit ? 'fit-content' : '' }"
			(click)="emitClick()"
			[disabled]="disabled"></p-button>
	`, isInline: true, styles: ["button{width:100%}\n"], dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "ngmodule", type: ButtonModule }, { kind: "component", type: i1.Button, selector: "p-button", inputs: ["type", "iconPos", "icon", "badge", "label", "disabled", "loading", "loadingIcon", "raised", "rounded", "text", "plain", "severity", "outlined", "link", "size", "style", "styleClass", "badgeClass", "ariaLabel"], outputs: ["onClick", "onFocus", "onBlur"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ButtonComponent, decorators: [{
            type: Component,
            args: [{ selector: 'a-button', standalone: true, imports: [CommonModule, ButtonModule], template: `
		<p-button
			[loading]="loading"
			[label]="label"
			[severity]="severity"
			[rounded]="rounded"
			[text]="text"
			[raised]="raised"
			[outlined]="outlined"
			[styleClass]="class"
			[icon]="icon"
			[iconPos]="iconPos"
			[style]="{ width: fit ? 'fit-content' : '' }"
			(click)="emitClick()"
			[disabled]="disabled"></p-button>
	`, changeDetection: ChangeDetectionStrategy.OnPush, styles: ["button{width:100%}\n"] }]
        }], propDecorators: { label: [{
                type: Input
            }], icon: [{
                type: Input
            }], iconPos: [{
                type: Input
            }], class: [{
                type: Input
            }], fit: [{
                type: Input
            }], disabled: [{
                type: Input
            }], loading: [{
                type: Input
            }], severity: [{
                type: Input
            }], clicked: [{
                type: Output
            }], text: [{
                type: Input
            }], rounded: [{
                type: Input
            }], raised: [{
                type: Input
            }], outlined: [{
                type: Input
            }] } });

/**
 * Generated bundle index. Do not edit.
 */

export { ButtonComponent };
